import { createContext, useContext } from 'react';

export interface WorkflowNodeContextValue {
  openProperties: (nodeId: string) => void;
}

const WorkflowNodeContext = createContext<WorkflowNodeContextValue | null>(null);

export function useWorkflowNodeContext(): WorkflowNodeContextValue | null {
  return useContext(WorkflowNodeContext);
}

export const WorkflowNodeContextProvider = WorkflowNodeContext.Provider;
